export default __webpack_public_path__ + "static/media/AbdallahSafar.b1f61bcf.jpg";